/**
 * What an administration section shows for its list.
 *
 * A section starts with an empty array before its first answer has come, and an
 * empty array read as "nothing here" tells a person on a slow line that their
 * services are gone. So nothing counts as empty until an answer has come. Rows
 * that are already on screen are shown whatever the flag says: a save can land
 * before the first read does, and hiding its row behind "Loading" would be wrong.
 */
export type ListState = 'loading' | 'empty' | 'list'

/** What a section shows: nothing is "empty" before the first answer has come. */
export function listState(loaded: boolean, count: number): ListState {
  if (count > 0) return 'list'
  return loaded ? 'empty' : 'loading'
}
